import type { ReactNode } from 'react';
import { Paper, Typography } from '@mui/material';

/**
 * A view's summary figure above its tabs or table: a label, the figure, and under it what qualifies it. One look for the
 * budget rollup's tiles and the pre-calculation's key figures, so a figure reads the same wherever it stands.
 */
export function SummaryTile({ label, value, color, children }: {
  label: string;
  value: string;
  /** The figure's colour when it says something on its own — not submitted yet, a loss. */
  color?: string;
  /** Notes under the figure, each a caption. */
  children?: ReactNode;
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, minWidth: 220 }}>
      <Typography variant="overline" color="text.secondary">{label}</Typography>
      <Typography variant="h5" color={color} sx={{ fontVariantNumeric: 'tabular-nums' }}>{value}</Typography>
      {children}
    </Paper>
  );
}
